
export type GetProfileByUsername404 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
